"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(event, check) {
  return {
    _isMBTransition: true,
    event: event,
    check: check
  };
};

exports.default = _default;